
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Subscription } from 'rxjs';
export class IsEqualOrGreaterThanValidator {
    static EqualOrGreaterThan(equalOrGreaterThanControlName): ValidatorFn {

        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.root) return null;

            const controlMatch = control.root.get(equalOrGreaterThanControlName);

            if (!controlMatch) return null;

            const subscription: Subscription = controlMatch.valueChanges.subscribe(() => {
                control.updateValueAndValidity();
                subscription.unsubscribe();
            });

            if (+control.value < +controlMatch.value) {
                controlMatch.setErrors({ 'isEqualOrLessThan': true });
                return { 'isEqualOrGreaterThan': true };
            }

            if (controlMatch.errors) {
                delete controlMatch.errors['isEqualOrLessThan'];
                controlMatch.updateValueAndValidity({ emitEvent: false });
            }

            return null;
        };
    }
}

